import styled from 'styled-components';
export const StyledSelectorRowContainer = styled.div `
  flex: 0;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(4)}`};
  background-color: ${(props) => props.theme.palette.background.pageContextControl};
`;
